<rask-page pageTitle="Rebus" noPadding>
    <rask-container-block>
        <div>
            <rask-checkbox text="Uppdatera var 30 sekund" [(ngModel)]="autoRefresh"
                (change)="onAutoRefreshChange($event)">
            </rask-checkbox>
            <rask-checkbox text="Visa endast köer med > 0 event" [(ngModel)]="nonZeroQueues"
                (change)="nonZeroQueuesChange($event)">
            </rask-checkbox>
        </div>
        <rask-list [data]="queuesFiltered" [useClientFilter]="true" clientFilterResultText="köer">
            <rask-list-column header="Kö-namn" field="queue" [sortable]="true"></rask-list-column>
            <rask-list-column header="Antal meddelanden" field="messageCount" [sortable]="true">
                <ng-template let-row="row">
                    <div>
                        <a [routerLink]="['/rebus', row.type, row.queue]">
                            {{ row.messageCount }}
                        </a>
                        <rask-icon-button aid="buttonPurgeQueue" (click)="purgeQueue(row)" icon="far fa-trash-alt"
                            negative [disabled]="!hasMessages(row)"></rask-icon-button>
                    </div>
                </ng-template>
            </rask-list-column>
            <rask-list-column header="Error meddelanden" field="errorCount" [sortable]="true">
                <ng-template let-row="row">
                    <div>
                        <a [routerLink]="['/rebus', row.type, row.queue, row.errorSubQueue]"
                            [ngClass]="{'errorText': row.errorCount > 0}">
                            {{ row.errorCount }}
                        </a>
                        <rask-icon-button aid="buttonPurgeErrorQueue" (click)="purgeErrorQueue(row)"
                            icon="far fa-trash-alt" negative [disabled]="!hasErrors(row)"></rask-icon-button>
                    </div>
                </ng-template>
            </rask-list-column>
            <rask-list-column header="Topics" field="topics" [sortable]="true"></rask-list-column>
            <rask-list-column header="Miljö" field="environment"></rask-list-column>
        </rask-list>
    </rask-container-block>
</rask-page>